import React, { useEffect, useState } from 'react';
import PageTitle from '../Components/PageTitle';
import AxiosApi from '../Helper/axios.api';
import { useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";

export default function UserList() {
    const auth = useSelector((state) => state.auth);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const fetchData = async () => {
        setIsLoading(true);
        try {
            const data = { user_id: auth.userDeatils.user_id, limit:-1 }
            const response = await AxiosApi.withToken(auth.accessToken, "admin/user", "post", data);

            if (response.login === false) {
                dispatch(logout());
                navigate("/login", { replace: true });
            }
            if (!response.status) throw Error(response.message);
            setData(response.data);
        } catch (error) {
            console.error(error);
            toast.error(error.message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);
    const toggleBlockUser = async (user) => {

        setIsLoading(true);
        try {
            const data = {
                user_id: auth.userDeatils.user_id,
                target_user_id: user.user_id,
                is_active: !user.is_active,
            }
            const response = await AxiosApi.withToken(auth.accessToken, "admin/block_user", "post", data);
            if (!response.status) throw Error(response.message);

        } catch (error) {
            console.error(error);
            toast.error(error.message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } finally {
            setIsLoading(false);
        }

        await fetchData();
    }
    return (
        <>
            <PageTitle title="DeepTherapy | Users trainings" />
            <div className="virtualization">
                <div className="card w-100">
                    <div className="card-body">
                        <table>
                            <thead>
                                <tr style={{backgroundColor: '#f1f1f1'}}>
                                    {['Created at', 'email', 'Credits', 'Block User', 'Action'].map((header, index) => (
                                        <th key={index} className='p-2 text-center'>
                                            {header}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody style={{opacity: isLoading ? .5 : 1}}>
                                {data.users && data.users.map((user,index) => (
                                    <tr key={index}>
                                        <td className='p-2'>
                                            {user.create_at}
                                        </td>
                                        <td className='p-2'>
                                            <i className="fas fa-user-circle"></i> {user.email}
                                        </td>
                                        <td className='p-2'>
                                            <i className="fas fa-coins"></i> {user.total_coin}
                                        </td>
                                        <td className='p-2'>
                                            <label className="toggle-switch">
                                                <input
                                                    disabled={isLoading}
                                                    type="checkbox"
                                                    className="block-toggle"
                                                    checked={!user.is_active}
                                                    onChange={() => toggleBlockUser(user)}
                                                />
                                                <span className="toggle-slider"></span>
                                            </label>
                                            {" "}{user.is_active ? "Allowed" : "Blocked"}
                                        </td>
                                        <td className='p-2'>
                                            <Link to={`mailto:${user.email}`} className="btn btn-primary">
                                                <i className="fas fa-envelope"></i>
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <style jsx="true">{`
                .toggle-switch {
                    position: relative;
                    display: inline-block;
                    width: 48px;
                    height: 24px;
                }

                .toggle-switch input {
                    opacity: 0;
                    width: 0;
                    height: 0;
                }

                .toggle-slider {
                    position: absolute;
                    cursor: pointer;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: #ccc;
                    transition: .4s;
                    border-radius: 24px;
                }

                .toggle-slider:before {
                    position: absolute;
                    content: "";
                    height: 18px;
                    width: 18px;
                    left: 3px;
                    bottom: 3px;
                    background-color: white;
                    transition: .4s;
                    border-radius: 50%;
                }

                input:checked + .toggle-slider {
                    background-color: #2196F3;
                }

                input:focus + .toggle-slider {
                    box-shadow: 0 0 1px #2196F3;
                }

                input:checked + .toggle-slider:before {
                    transform: translateX(24px);
                }
            `}</style>
        </>
    );
}
